import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

import { Provider } from "react-redux";
import store from "./store";

import firebase from "./services/firebase";
import { getCurrentUserFavoriteColors, initCurrentUser } from "./store/user";

import "semantic-ui-css/semantic.min.css";
import "./assets/css/style.scss";

firebase.auth().onAuthStateChanged(async currentUser => {
    currentUser &&
        currentUser.displayName &&
        !store.getState().user.currentUser &&
        store.dispatch(initCurrentUser(currentUser));

    currentUser && (await store.dispatch(getCurrentUserFavoriteColors()));

    ReactDOM.render(
        <Provider store={store}>
            <App currentUser={currentUser} />
        </Provider>,

        document.getElementById("root"),
    );
});
